import { render } from "./smartphone.vue?vue&type=template&id=1dae05d6"
import script from "./smartphone.vue?vue&type=script&lang=js"
export * from "./smartphone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__